import ScrollReveal from '@/components/ScrollReveal';

const steps = [
  {
    step: 1,
    title: 'Initial Assessment',
    desc: 'We evaluate your capital requirements, credit profile, market conditions, and optimal instrument type to develop a preliminary structuring thesis.',
  },
  {
    step: 2,
    title: 'Structuring & Documentation',
    desc: 'Our team designs the bond terms, covenant package, maturity profile, and pricing parameters. For sukuk, we establish SPV architecture and Sharia-compliant frameworks.',
  },
  {
    step: 3,
    title: 'Rating & Compliance',
    desc: 'We coordinate with credit rating agencies, legal counsel, and regulators to secure necessary approvals, ratings, and regulatory clearances.',
  },
  {
    step: 4,
    title: 'Investor Marketing',
    desc: 'Targeted roadshows, investor presentations, and syndication campaigns to build demand. We leverage our global institutional network for optimal book building.',
  },
  {
    step: 5,
    title: 'Execution & Settlement',
    desc: 'Precise pricing, allocation, and settlement execution. Post-issuance, we provide ongoing investor relations support and liability monitoring.',
  },
];

export default function Process() {
  return (
    <section id="process" className="bg-white py-20 sm:py-28">
      <div className="max-w-7xl mx-auto px-4 sm:px-6">
        <ScrollReveal>
          <p className="text-sm font-inter font-semibold uppercase tracking-wider mb-3" style={{ color: '#c9a84c' }}>
            Our Process
          </p>
          <h2 className="font-playfair font-bold text-3xl sm:text-4xl mb-14" style={{ color: '#0a1628' }}>
            From Mandate to Market in Five Steps
          </h2>
        </ScrollReveal>

        <div className="grid sm:grid-cols-2 lg:grid-cols-5 gap-8 lg:gap-5">
          {steps.map((step, i) => (
            <ScrollReveal key={step.step} delay={i * 100}>
              <div className="relative" data-testid={`process-step-${step.step}`}>
                {/* Connector line (desktop) */}
                {i < steps.length - 1 && (
                  <div
                    className="hidden lg:block absolute top-5 h-px"
                    style={{
                      left: '44px',
                      right: '-20px',
                      backgroundColor: 'rgba(201,168,76,0.2)',
                    }}
                  />
                )}
                {/* Step circle */}
                <div
                  className="relative z-10 w-10 h-10 rounded-full font-playfair font-bold text-lg flex items-center justify-center mb-4"
                  style={{ backgroundColor: '#c9a84c', color: '#060f1d' }}
                >
                  {step.step}
                </div>
                <h3 className="font-inter font-semibold text-base mb-2" style={{ color: '#0a1628' }}>
                  {step.title}
                </h3>
                <p className="font-inter text-sm leading-relaxed" style={{ color: '#6b7280' }}>
                  {step.desc}
                </p>
              </div>
            </ScrollReveal>
          ))}
        </div>
      </div>
    </section>
  );
}
